import React from 'react';
import cn from 'classnames';
import { ArrowDownIcon_16, ArrowUpIcon_16 } from 'assets/icons';
import styles from './PriceChange.module.css';

type PriceChangeProps = {
  amount: number;
};

const PriceChange: React.FC<PriceChangeProps> = ({ amount }) => {
  const a = 1;
  return (
    <div
      className={cn([
        styles.wrapper,
        amount > 0 ? styles.wrapper__positive : styles.wrapper__negative,
      ])}
    >
      <div className={cn(styles.icon)}>
        {amount > 0 ? <ArrowUpIcon_16 /> : <ArrowDownIcon_16 />}
      </div>
      <span className={cn(styles.value)}>
        {Math.abs(amount)}
        {'%'}
      </span>
    </div>
  );
};

export default PriceChange;
